const theme = {
  screen: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
  },
  spacing: {
    px: '1px',
    s0: '0',
    s1: '0.25rem',
    s2: '0.5rem',
    s3: '0.75rem',
    s4: '1rem',
    s5: '1.25rem',
    s6: '1.5rem',
    s8: '2rem',
    s10: '2.5rem',
    s12: '3rem',
    s16: '4rem',
    s20: '5rem',
    s24: '6rem',
    s32: '8rem',
    s40: '10rem',
    s48: '12rem',
    s56: '14rem',
    s64: '16rem'
  },
  fontSize: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    xl2: '1.5rem',
    xl3: '1.875rem',
    xl4: '2.25rem',
    xl5: '3rem',
    xl6: '4rem'
  },
  fontWeight: {
    hairline: '100',
    thin: '200',
    light: '300',
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    extrabold: '800',
    black: '900'
  },
  maxWidth: {
    none: 'none',
    xs: '20rem',
    sm: '24rem',
    md: '28rem',
    lg: '32rem',
    xl: '36rem',
    full: '100%'
  },
  maxHeight: {
    full: '100%',
    screen: '100vh'
  },
  minHeight: {
    zero: '0',
    full: '100%',
    screen: '100vh'
  },
  color: {
    transparent: 'transparent',
    black: '#000',
    white: '#fff',
    gray: {
      light: '#edf2f7',
      medium: '#718096',
      dark: '#2d3748',
      darker: '#1a202c'
    },
    blue: {
      light: '#4299e1',
      dark: '#2b6cb0'
    },
    red: {
      light: '#fed7d7',
      medium: '#f56565',
      dark: '#c53030',
      darker: '#9b2c2c'
    }
  },
  borderRadius: {
    none: '0',
    sm: '0.125rem',
    default: '0.25rem',
    lg: '0.5rem',
    full: '9999px'
  },
  boxShadow: {
    default: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg:
      '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl:
      '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    xxl: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    outline: '0 0 0 3px rgba(66, 153, 225, 0.5)',
    none: 'none'
  },
  width: {
    w1_2: '50%',
    w1_3: '33.333333%',
    w2_3: '66.666667%',
    w1_4: '25%',
    w2_4: '50%',
    w3_4: '75%',
    w1_5: '20%',
    w2_5: '40%',
    w3_5: '60%',
    w4_5: '80%',
    w1_6: '16.666667%',
    w2_6: '33.333333%',
    w3_6: '50%',
    w4_6: '66.666667%',
    w5_6: '83.333333%',
    w1_12: '8.333333%',
    w2_12: '16.666667%',
    w3_12: '25%',
    w4_12: '33.333333%',
    w5_12: '41.666667%',
    w6_12: '50%',
    w7_12: '58.333333%',
    w8_12: '66.666667%',
    w9_12: '75%',
    w10_12: '83.333333%',
    w11_12: '91.666667%',
    full: '100%',
    screen: '100vw'
  },
  height: {
    full: '100%',
    screen: '100vh'
  }
};

export default theme;
